module.exports = __webpack_public_path__ + "img/savology-visual-design.c9f7c9a9.png";